import ErrorBoundary from 'components/ErrorBoundary';
import Experiences from 'components/Experiences';
import FeaturedExperiences from 'components/templates/FeaturedExperiencesContainer/FeaturedExperiencesContainer';
import Hero from 'components/Hero';
import { Wrapper, WrapperFluid } from 'components/theme/Wrapper';
import React from 'react';

import { useAppState } from 'AppProvider';
import { HomePageAnalyticsTracker } from 'features/analytics/components/HomePageAnalyticsTracker';

const Home = () => {
  const { brand } = useAppState();
  const { experiences } = useAppState((state) => state.experience);

  return (
    <WrapperFluid id="way-home__wrapper-fluid-container">
      <HomePageAnalyticsTracker listings={experiences} />
      <ErrorBoundary>
        {brand.settings && <Hero settings={brand.settings} />}
      </ErrorBoundary>
      <ErrorBoundary>
        {/* FeaturedExperiencesContainer no longer wraps itself; this legacy page is full-bleed
            (WrapperFluid), so constrain featured here to match the rest of the page. */}
        <Wrapper>
          <FeaturedExperiences />
        </Wrapper>
      </ErrorBoundary>
      <ErrorBoundary>
        <Experiences
          classId="home-page-experiences"
          limit={48}
          hidePagination
          showTitle
          redirectToSearch
        />
      </ErrorBoundary>
    </WrapperFluid>
  );
};

export default Home;
